var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-add-designation",
                                  modifiers: { "modal-add-designation": true },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add New Designation "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-modal",
                        {
                          ref: "addDesignation",
                          attrs: {
                            id: "modal-add-designation",
                            "ok-only": "",
                            "ok-title": "Add",
                            centered: "",
                            size: "lg",
                            title: "Add Designation",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("AddDesignation", {
                            on: { DesignationAdded: _vm.closeAddModal },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredDesignations,
                          fields: _vm.designation_fields,
                          "filter-included-fields": _vm.filterOn,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(departmentName)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "departmentName"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Department Name")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Filter by Department Name",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.departmentName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "departmentName",
                                            $$v
                                          )
                                        },
                                        expression: "filters.departmentName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(designationName)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "designationName"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Designation Name")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Filter by Designation Name",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.designationName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "designationName",
                                            $$v
                                          )
                                        },
                                        expression: "filters.designationName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(workingHours)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "workingHours"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Working Hours")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Working Hours",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.workingHours,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "workingHours",
                                            $$v
                                          )
                                        },
                                        expression: "filters.workingHours",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(minimumSalary)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "minimumSalary"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Minimum Salary")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Minimum Salary",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.minimumSalary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "minimumSalary",
                                            $$v
                                          )
                                        },
                                        expression: "filters.minimumSalary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(maximumSalary)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "maximumSalary"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Maximum Salary")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Maximum Salary",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.maximumSalary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "maximumSalary",
                                            $$v
                                          )
                                        },
                                        expression: "filters.maximumSalary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName:
                                              "v-b-modal.modal-edit-designation",
                                            modifiers: {
                                              "modal-edit-designation": true,
                                            },
                                          },
                                        ],
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editDesignation(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeDesignation(
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticStyle: { width: "3rem", height: "3rem" },
                                attrs: {
                                  variant: "success",
                                  label: "Spinning",
                                  block: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "editDesignation",
                          attrs: {
                            id: "modal-edit-designation",
                            "ok-only": "",
                            "ok-title": "Edit",
                            centered: "",
                            size: "lg",
                            title: "Edit Designation",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("EditDesignation", {
                            attrs: { designation: _vm.currentDesignation },
                            on: { DesignationUpdated: _vm.closeEditModal },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }